<template>
    <div>
        <div
            v-if="types.length"
            class="field is-grouped mb-5"
        >
            <p class="control">
                <strong>
                    Filter:
                </strong>
            </p>
            <p class="mt-1">
                <b-checkbox
                    v-for="option in types"
                    :key="option"
                    v-model="selectedTypes"
                    :native-value="option"
                    :disabled="isDisabled"
                    class="mr-5 mb-4"
                >
                    {{ option }}
                </b-checkbox>

                <b-button
                    v-if="types.length > 1"
                    size="is-small"
                    class="has-text-weight-bold"
                    @click="toggleSelection"
                    :disabled="isDisabled"
                >
                    {{ (isAllTypesSelected ? "Deselect" : "Select") }} all
                </b-button>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        types: {
            type: Array,
            default: () => [],
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
    },

    data: function() {
        return {
            selectedTypes: [],
        };
    },

    computed: {
        isAllTypesSelected() {
            return (this.types.length === this.selectedTypes.length);
        },
    },

    watch: {
        selectedTypes: function (value) {
            this.$emit('update:selectedTypes', value);
        },
        types: function (value) {
            // select all note types
            this.selectedTypes = value;

            // attempt to get value from GET parameters
            if(this.$route.query.selectedTypes && this.$route.query.selectedTypes.length) {
                // convert string to array if only one type is selected
                this.selectedTypes = (Array.isArray(this.$route.query.selectedTypes) ? this.$route.query.selectedTypes : [this.$route.query.selectedTypes]);
            }
        },
    },

    methods: {
        toggleSelection() {
            if(this.isAllTypesSelected) {
                this.selectedTypes = [];
            } else {
                this.selectedTypes = this.types;
            }
        },
    },
};
</script>
